<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>
                <div class="divisor32"></div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Ciclo'" [disabled]="true" [(ngModel)]="entidad.ciclo" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nombre del periodo de evaluación'" [disabled]="true" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <datePickerV2Custom [titulo]="'Fecha Inicio de Periodo'" [disabled]="true"
                            [errorActivo]="errorActivo"
                            [(ngModel)]="entidad.fechainicioperiodo"
                            ></datePickerV2Custom>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <datePickerV2Custom [titulo]="'Fecha Inicio Acuerdos'" [disabled]="true"
                            [(ngModel)]="entidad.fechainicioacuerdos"
                            ></datePickerV2Custom>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12 col-12">
                        <datePickerV2Custom [titulo]="'Fecha Fin Acuerdos'" [disabled]="true"
                            [(ngModel)]="entidad.fechafinacuerdos"
                            ></datePickerV2Custom>
                    </div>
                </div>

                <div *ngIf="accion.accionid == 1">
                    <h5>Asigne las plantillas de preguntas disponibles para la evaluación</h5>

                    <checkBoxCustom [titulo]="'Ver solo plantillas asignadas'" [(ngModel)]="MostrarAsignados" (ngModelChange)="CambiarInfoTabla($event)" [alineacion]="1"></checkBoxCustom>
                    <!-- datos -->
                    <div >
                        <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="DataPlantilla"
                            [hoverStateEnabled]="true"
                            keyExpr="plantillaid"
                            [noDataText]="'Sin Datos'"
                            [(selectedRowKeys)]="selectedRows"
                            [showColumnHeaders]="true"
                            >
                            <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>

                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>
                            <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'"></dxo-selection>
                            <dxi-column
                                [allowExporting]="false"
                                caption="Acciones"
                                cellTemplate="cellAcciones"
                                alignment="center"
                                [minWidth]="120">

                            </dxi-column>
                            <dxi-column
                                dataField="selected"
                                type="selection"
                                alignment="center">
                            </dxi-column>
                            <dxi-column
                                dataField="descripcion"
                                caption="Descripción">
                            </dxi-column>
                            <dxi-column
                                dataField="evaluador"
                                caption="Evaluadores">
                            </dxi-column>
                            <dxi-column
                                dataField="grado"
                                caption="Nivel y Grado">
                            </dxi-column>
                            <!-- Acciones -->
                            <div *dxTemplate="let cell of 'cellAcciones'">
                                <a matTooltip="Ver" class="tablaBoton" (click)="Formulario(cell.data)">
                                    <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                                </a>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>


                <div *ngIf="accion.accionid == 2">
                    <h5>Asigne preguntas a los puestos</h5>
                    <!-- datos -->
                    <div >
                        <dx-data-grid
                            (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                            id="tabla"
                            [columnAutoWidth]="true"
                            [dataSource]="DataPuestos"
                            [noDataText]="'Sin Datos'"
                            [hoverStateEnabled]="true"
                            [showColumnHeaders]="true"
                            >
                            <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>
                            <dxo-search-panel
                                [visible]="true"
                                [width]="240"
                                placeholder="{{'Buscar' | translate}}">
                            </dxo-search-panel>
                            <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                            <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->
                            <dxo-pager
                                [visible]="true"
                                [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                                [displayMode]="sistemaService.tablaPaginacionModo"
                                [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                                [showInfo]="sistemaService.tablaPaginacionInfo"
                                [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                            </dxo-pager>
                            <dxi-column
                                [allowExporting]="false"
                                caption="Acciones"
                                cellTemplate="cellPreguntas"
                                alignment="center"
                                [minWidth]="120">
                            </dxi-column>
                            <dxi-column
                                dataField="departamento"
                                caption="Departamento">
                            </dxi-column>
                            <dxi-column
                                dataField="nombre"
                                caption="Puesto">
                            </dxi-column>
                            <dxi-column
                                dataField="fechaedicion"
                                caption="Última edición">
                            </dxi-column>
                            <dxi-column
                                dataField="usuario"
                                caption="Editó">
                            </dxi-column>
                            <!-- Acciones -->
                            <div *dxTemplate="let cell of 'cellPreguntas'">
                                <button class="btn boton botonXS"
                                    (click)="VerPreguntasParaAsignar(cell.data.puestoid, cell.data.departamentoid)">
                                    <span> {{'Asignar Preguntas'}}</span>
                                </button>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
                <div class="divisor20"></div>
                <div class="row margen" >
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                                    (click)="Salir()">
                                <span> {{'Cancelar'}}</span>
                            </button>
                            <div class="divisorH16 " ></div>
                            <button matTooltip="Guardar" class="boton botonSM filled"
                                    (click)="Guardar()" [disabled]="ver"
                                    *ngIf="sistemaService.permisos.agregar && accion.accionid == 1">
                                <span> {{'Guardar'}}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>

<div #plantillaFormulario></div>
<div #preparacionevaluacionPregunta></div>
